'use strict';

var removeEmptyPassword = require('./middlewares/removeEmptyPassword');

module.exports = {
  model: 'users',
  middlewares: [removeEmptyPassword]
};


//////////////////
// WEBPACK FOOTER
// ./~/coact/views/users.js
// module id = 1748
// module chunks = 0